module.exports = __webpack_public_path__ + "media/images/button-arrow-1182b957d4c441cd8015b6f05c536afc.svg";